
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mask } from "vue-the-mask";
// import VueSelect from "vue-select";
// import CardForm from "@/modules/Assinatura/Cards/CardForm.vue";
import Card from "@/modules/Assinatura/Cards/Card.vue";
import loadsh from "loadsh";

export default {
  name: "app-link-payment",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },

  data() {
    return {
      consultaCepFire: false,
      selectedCity: null,
      finishedPayment: false,
      fields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv",
      },
      uuid: null,
      formIdentificacao: {
        nome: null,
        email: null,
        cpf_cnpj: null,
        telefone: null,
        celular: null,
      },
      isCardNumberMasked: true,
      formEndereco: {
        logradouro: null,
        bairro: null,
        cidade: null,
        estado: null,
        complemento: null,
        numero: null,
        cep: null,
      },
      cidades: [],
      formCartao: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
        cardVezes: "",
      },
      assinatura: {
        status: null,
        data_validade: null,
        data_pagamento: null,
        motivo_bloqueio: null,
        valor: null,
        id_plan: null,
        plano: null,
      },
      id_empresa: null,
      parcelas: [],
      isSale: false,
      essencialMonthly: "3",
      essencialYearly: "2",
      minCardYear: new Date().getFullYear(),
    };
  },
  components: {
    FormWizard,
    TabContent,
    Card,
    // VueSelect,
    // CardForm,
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getInit() {},
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n;
    },
    onChangeCidadeSelected() {
      this.formEndereco.cidade = this.selectedCity.cidade;
      this.formEndereco.estado = this.selectedCity.uf;
    },
    validateStep(step) {
      if (step === 1) {
        if (
          !!this.formIdentificacao.nome &&
          this.formIdentificacao.nome !== "" &&
          !!this.formIdentificacao.email &&
          this.formIdentificacao.email !== "" &&
          !!this.formIdentificacao.cpf_cnpj &&
          this.formIdentificacao.cpf_cnpj !== "" &&
          !!this.formIdentificacao.celular &&
          this.formIdentificacao.celular !== ""
        )
          return true;
        else {
          this.$toast.error("Preencha todos os campos!");
          return false;
        }
      }
      if (step === 2) {
        if (
          !!this.formEndereco.cep &&
          this.formEndereco.cep !== "" &&
          !!this.formEndereco.logradouro &&
          this.formEndereco.logradouro !== "" &&
          !!this.formEndereco.numero &&
          this.formEndereco.numero !== "" &&
          !!this.formEndereco.bairro &&
          this.formEndereco.bairro !== "" &&
          !!this.formEndereco.cidade &&
          this.formEndereco.cidade !== "" &&
          !!this.formEndereco.estado &&
          this.formEndereco.estado !== ""
        )
          return true;
        else {
          this.$toast.error("Preencha todos os campos!");
          return false;
        }
      }
      if (step === 3) {
        if (
          !!this.formCartao.cardCvv &&
          this.formCartao.cardCvv !== "" &&
          !!this.formCartao.cardMonth &&
          this.formCartao.cardMonth !== "" &&
          !!this.formCartao.cardYear &&
          this.formCartao.cardYear !== "" &&
          !!this.formCartao.cardName &&
          this.formCartao.cardName !== "" &&
          !!this.formCartao.cardNumber &&
          this.formCartao.cardNumber !== "" &&
          !!this.formCartao.cardVezes &&
          this.formCartao.cardVezes !== ""
        )
          return true;
        else {
          this.$toast.error("Preencha todos os campos!");
          return false;
        }
      }
    },
    async handleSendPayment() {
      this.setLoading(true);
      const dataToSendToPayment = {
        uuid: this.uuid,
        id_empresa: this.id_empresa,
        ...this.formIdentificacao,
        cpf_cnpj: this.normalizeCpfCnpj(this.formIdentificacao.cpf_cnpj),
        name: this.formIdentificacao.nome,
        ...this.formEndereco,
        uf: this.formEndereco.estado,
        numero_cartao: this.formCartao.cardNumberNotMask,
        nome_cartao: this.formCartao.cardName,
        ano: this.formCartao.cardYear,
        mes: this.formCartao.cardMonth,
        cvv: this.formCartao.cardCvv,
        vezes: this.formCartao.cardVezes,
      };
      try {
        await this.$http.post("/link/pagar-link", dataToSendToPayment);
        this.setLoading(false);
        this.finishedPayment = true;
        this.$swal
          .fire({
            icon: "success",
            title: "Obrigado por realizar a compra!",
            confirmButtonText: `Fechar`,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              // this.$router.push({ name: "comprasLista" });
            }
          });
      } catch (error) {
        this.setLoading(false);
        console.log(JSON.stringify(error));
      }
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades = city;
      loading(false);
    }, 350),
    async consultaCep() {
      this.setLoading(true);
      const cep = await this.getCep(this.formEndereco.cep);
      this.setLoading(false);
      cep.length === 0
        ? (this.consultaCepFire = false)
        : (this.consultaCepFire = true);
      this.formEndereco.logradouro = cep.logradouro;
      this.formEndereco.bairro = cep.bairro;
      const city = await this.getCidadeByUF(cep.localidade, cep.uf);
      this.cidades = city;
    },
    changeName(e) {
      this.formCartao.cardName = e.target.value;
      this.$emit("input-card-name", this.formCartao.cardName);
    },
    changeNumber(e) {
      this.formCartao.cardNumber = e.target.value;
      let value = this.formCartao.cardNumber.replace(/\D/g, "");
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.formCartao.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 17;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.formCartao.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.formCartao.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }
      // eslint-disable-next-line eqeqeq
      if (e.inputType == "deleteContentBackward") {
        let lastChar = this.formCartao.cardNumber.substring(
          this.formCartao.cardNumber.length,
          this.formCartao.cardNumber.length - 1
        );
        // eslint-disable-next-line eqeqeq
        if (lastChar == " ") {
          this.formCartao.cardNumber = this.formCartao.cardNumber.substring(
            0,
            this.formCartao.cardNumber.length - 1
          );
        }
      }
      this.$emit("input-card-number", this.formCartao.cardNumber);
    },
    changeMonth() {
      this.$emit("input-card-month", this.formCartao.cardMonth);
    },
    changeYear() {
      this.$emit("input-card-year", this.formCartao.cardYear);
    },
    changeCvv(e) {
      this.formCartao.cardCvv = e.target.value;
      this.$emit("input-card-cvv", this.formCartao.cardCvv);
    },
    blurCardNumber() {
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      }
    },
    maskCardNumber() {
      this.formCartao.cardNumberNotMask = this.formCartao.cardNumber;
      this.mainCardNumber = this.formCartao.cardNumber;
      let arr = this.formCartao.cardNumber.split("");
      arr.forEach((element, index) => {
        if (index > 4 && index < 14 && element.trim() !== "") {
          arr[index] = "*";
        }
      });
      this.formCartao.cardNumber = arr.join("");
    },
    unMaskCardNumber() {
      this.formCartao.cardNumber = this.mainCardNumber;
    },
    focusCardNumber() {
      this.unMaskCardNumber();
    },
    toggleMask() {
      this.isCardNumberMasked = !this.isCardNumberMasked;
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      } else {
        this.unMaskCardNumber();
      }
    },
    // eslint-disable-next-line no-unused-vars
    updateCardNumber(val) {},
    // eslint-disable-next-line no-unused-vars
    updateCardName(val) {},
    // eslint-disable-next-line no-unused-vars
    updateCardMonth(val) {},
    // eslint-disable-next-line no-unused-vars
    updateCardYear(val) {},
    // eslint-disable-next-line no-unused-vars
    updateCardCvv(val) {},
  },
  mounted() {
    this.getInit();
  },
  created() {
    const { uuid } = this.$route.params;
    this.setLoading(true);
    this.$http
      .post("/link/busca-link", {
        uuid,
      })
      .then((response) => {
        this.parcelas = response.data.vezes;
        this.uuid = uuid;
        this.id_empresa = response.data.id_empresa;
        this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        this.$toast.error(`Erro ao buscar pagamento:\n${error}`);
        this.$router.push({ name: 404 });
      });
  },
};
